<template>
  <div class="c-sideMenuOverlay" :class="{ 'is-open': isOpen }">
    <transition name="fade">
      <div
        class="c-sideMenuOverlay__background"
        @click="close"
        v-if="isOpen"
      ></div>
    </transition>
    <div class="c-sideMenuOverlay__inner" :class="placementClass">
      <div class="c-sideMenuOverlay__header">
        <div
          class="c-sideMenuOverlay__header__close o-btn o-btn--back"
          v-if="isOpen"
          @click="close"
        >
          <iBtnArrow />
          Tilbage
        </div>
      </div>
      <div class="c-sideMenuOverlay__body">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import iBtnArrow from '@web/assets/icon/btnArrow.svg';

export default {
  name: 'SideMenuOverlay',
  components: {
    iBtnArrow,
  },

  data: () => ({
    isMenu: true,
    isApps: false,
    isContact: false,
    isLogin: false,
    isBasket: false,
  }),

  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    placement: {
      type: String,
      default: 'right',
    },
    showLoader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    placementClass() {
      return 'c-sideMenuOverlay__inner' + '--' + this.placement;
    },
  },
  methods: {
    close() {
      this.isMenu = true;
      this.isApps = false;
      this.isContact = false;
      this.$emit('close');
    },
    toggle() {},
    openMenu() {
      this.isMenu = true;
      this.isApps = false;
      this.isContact = false;
      this.isLogin = false;
      this.isBasket = false;
    },
    openContact() {
      this.isMenu = false;
      this.isApps = false;
      this.isContact = true;
      this.isLogin = false;
      this.isBasket = false;
    },
    openApps() {
      this.isMenu = false;
      this.isApps = true;
      this.isContact = false;
      this.isLogin = false;
      this.isBasket = false;
    },
    openLogin() {
      this.isMenu = false;
      this.isApps = false;
      this.isContact = false;
      this.isLogin = true;
      this.isBasket = false;
    },
    openBasket() {
      this.isMenu = false;
      this.isApps = false;
      this.isContact = false;
      this.isLogin = false;
      this.isBasket = true;
    },
  },
};
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';

.c-sideMenuOverlay {
  position: relative;

  &__background {
    background-color: $c-overlay;
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 20;
  }

  &__inner {
    display: flex;
    flex-direction: column;
    max-height: 100%;
    overflow-y: scroll;
    position: fixed;
    z-index: 20;
    top: 0;
    bottom: 0;
    opacity: 0;
    width: 100%;
    max-width: 450px;
    background-color: $c-white;
    bottom: 0;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    transition: transform 500ms $t-nice, opacity 300ms $t-nice;

    &::-webkit-scrollbar {
      width: 5px;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar-thumb {
      background-color: $c-darkblue;

      &:hover {
        background-color: darken($color: $c-darkblue, $amount: 10);
      }
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &--left {
      left: 0;
      transform: translate(-100%, 0);
    }

    &--right {
      right: 0;
      transform: translate(100%, 0);
    }

    .is-open & {
      opacity: 1;
      transform: translate(0, 0);
    }
  }

  &__header {
    padding-top: 75px;
    height: 35px;
    margin-bottom: 80px;
    padding-left: 60px;

    &__close {
      cursor: pointer;
      display: flex;
      font-size: 13px;
      font-weight: $f-bold;
      line-height: 16px;
      text-transform: uppercase;
      margin-left: -26px;

      svg {
        // transform: rotate(180deg);
        // margin-right: 10px;
        // width: 16px;
        .fill {
          fill: $c-red;
        }
      }
    }
  }

  &__body {
    width: 100%;
  }

  &.is-open {
    .c-sideMenuOverlay__inner {
      opacity: 1;
      transform: translate(0, 0);
    }
  }
}

@media all and (max-width: 425px) {
  .c-sideMenuOverlay {
    &__header {
      padding-left: 45px;
    }
  }
}
</style>
